import { StoreName } from './StoreName';

export enum SyncStatus {
  NotSet = 0,
  Ready,
  InProgress,
  Completed,
  Error,
  Invalid,
  ActionQueued,
}

export interface SyncTable {
  Id: number;
  tableName: string;
  primaryKeyPath: string;
  idIndexKeyPath?: string;
}
